<template>
  <span>
    {{ time | formatEpochDate(gmt) }}
  </span>
</template>

<script>
import gmt from '@/mixins/gmt';

export default {
  name: 'Clock',
  mixins: [gmt],
  data() {
    return {
      time: new Date(),
    };
  },
  mounted() {
    this.$options.interval = setInterval(this.updateDateTime, 1000);
  },
  beforeDestroy() {
    clearInterval(this.$options.interval);
  },
  methods: {
    updateDateTime() {
      this.time = new Date();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
